{
  "categories": {
    "identity_and_communication": { "label": "Identity & Communication" },
    "academic_assessment": { "label": "Academic Assessment" },
    "family_and_socioeconomic_context": {
      "label": "Family & Socioeconomic Context"
    },
    "learning_profile": { "label": "Learning Profile" },
    "accessibility_and_support_needs": {
      "label": "Accessibility & Support Needs"
    },
    "example_category": { "label": "Example category" },
    "feature_authoring": { "label": "Feature Authoring" }
  },
  "definitions": {
    "example": { "label": "Example" },
    "religion": { "label": "Religion" },
    "gender": { "label": "Gender" },
    "primary_language": { "label": "Primary Language" },
    "secondary_language": { "label": "Secondary Language" },
    "overall_qualitative_assessment": {
      "label": "Overall Qualitative Assessment"
    },
    "subject_grade": { "label": "Subject Grade" },
    "naplan": { "label": "NAPLAN" },
    "wisc_v": { "label": "WISC-V" },
    "wiat_iv": { "label": "WIAT-IV" },
    "wais_iv": { "label": "WAIS-IV" },
    "aeas": { "label": "AEAS" },
    "parent_socio_economic": { "label": "Parent Socio-economic Context" },
    "student_socio_economic": { "label": "Student Socio-economic Context" },
    "learning_style_description": { "label": "Learning Style Description" },
    "learning_style_vark": { "label": "VARK Learning Style" },
    "learning_style_gardner": { "label": "Gardner's Multiple Intelligences" },
    "learning_style_kolb": { "label": "Kolb's Experiential Learning Theory" },
    "learning_preference": { "label": "Learning Preferences" },
    "eyesight": { "label": "Eyesight" },
    "adhd": { "label": "ADHD" },
    "autism": { "label": "Autism" },
    "depression": { "label": "Depression" }
  },
  "fields": {
    "example": {
      "notes": { "label": "Notes" },
      "choices": { "label": "Choices" },
      "available": { "label": "Available" },
      "score": { "label": "Score" }
    },
    "learning_style_description": {
      "teaching_approaches": { "label": "Teaching Approaches" },
      "implementation_notes": { "label": "Implementation Notes" }
    }
  },
  "options": {
    "example": {
      "choices_v1": {
        "one": { "label": "One" }
      }
    },
    "learning_style_description": {
      "feature_learning_style_description_v1": {
        "collaborative": { "label": "Collaborative" }
      }
    }
  }
}
